import { ColorFieldTypesValues } from '@config/values/color-field-types.values';
import { IContentBuilderFieldColor } from '../models/content-builder-fields.model';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contentBuilderColor',
  standalone: true,
})
export class ContentBuilderColorPipe implements PipeTransform {
  transform(
    contentBuilderColor?: IContentBuilderFieldColor,
    defaultFallback?: string | IContentBuilderFieldColor,
  ): string {
    if (
      !contentBuilderColor ||
      !contentBuilderColor?.value ||
      !contentBuilderColor?.type ||
      contentBuilderColor.type === ColorFieldTypesValues.Default
    ) {
      if (!defaultFallback || typeof defaultFallback === 'string') {
        return defaultFallback?.split('-').length === 2
          ? `var(--ui-color-${defaultFallback})`
          : defaultFallback || '';
      }
      return this.transform(defaultFallback);
    }

    if (contentBuilderColor.type === ColorFieldTypesValues.Palette) {
      return `var(--ui-color-${contentBuilderColor.value})`;
    }

    if (contentBuilderColor.type === ColorFieldTypesValues.Hex) {
      return contentBuilderColor.value;
    }

    return '';
  }
}
